module.exports = __webpack_public_path__ + "img/Logo_House.74e5b297.png";